import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { Button } from '../../styles/GlobalComponents';
import { SidebarSubtitle, SidebarTitle } from '../../styles/stylesStyled';
import { cancelOrder } from '../../slices/orders-slice';

const CancelPaymentPackage = ({
  selectedPackage,
  setIsCancelModalOpen
}: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('packages');
  const { loading } = useAppSelector((state) => state.orders);

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <SidebarTitle>{t('are_you_sure')}</SidebarTitle>
          <SidebarSubtitle>{t('info_about_deletion')}</SidebarSubtitle>

          <Button
            m='20px auto 12px auto'
            onClick={() => {
              dispatch(
                cancelOrder({
                  userPackage: selectedPackage,
                  setIsCancelModalOpen
                })
              );
            }}>
            {t('cancel_confirm')}
          </Button>
          <Button
            negative
            m='0 auto'
            onClick={() => setIsCancelModalOpen(false)}>
            {t('cancel_payment')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CancelPaymentPackage;
